import ApiRequests from "../apiRequests";

class UserService extends ApiRequests{
    constructor(){
        super("users");
    }
}

export default UserService;